<div class="range-label">{{label}}</div>
<div class="range-line">
    <div class="range-spin">
        <ion-range [value]="percent" [disabled]="disabled" (ionChange)="onIonChange($event)"></ion-range>
    </div>
    <div class="range-mark">{{ percent }}%</div>
</div>
